import React, { useCallback, useState } from 'react';
import styles from './PreloadedGate.module.css';
import { logEvent } from '../../analytics';

// Filtre de courtoisie pour une page de demo : le code voyage dans le bundle
// JavaScript, il ecarte les visiteurs de passage mais ne resiste pas a la
// lecture du code source. Une vraie restriction demanderait un controle serveur.
const ACCESS_CODE = 'newdemo';
const STORAGE_KEY = 'saviol-preloaded-v2-unlocked';

function PreloadedGate({ children }) {
  const [unlocked, setUnlocked] = useState(() => localStorage.getItem(STORAGE_KEY) === 'true');
  const [code, setCode] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = useCallback(
    (event) => {
      event.preventDefault();

      if (code.trim().toLowerCase() !== ACCESS_CODE) {
        setError(true);
        logEvent('ui_interaction', 'preloaded_v2_access_denied');
        return;
      }

      localStorage.setItem(STORAGE_KEY, 'true');
      setUnlocked(true);
      logEvent('ui_interaction', 'preloaded_v2_access_granted');
    },
    [code]
  );

  const handleChange = useCallback((event) => {
    setCode(event.target.value);
    setError(false);
  }, []);

  if (unlocked) {
    return <>{children}</>;
  }

  return (
    <div className={styles.gate}>
      <form className={styles.card} onSubmit={handleSubmit}>
        <h1 className={styles.title}>Private preview</h1>
        <span className={styles.accentRule} aria-hidden="true" />
        <label className={styles.label} htmlFor="preloaded-access-code">
          Enter your access code to continue
        </label>
        <input
          id="preloaded-access-code"
          className={`${styles.input} ${error ? styles.inputError : ''}`}
          type="password"
          value={code}
          onChange={handleChange}
          autoComplete="off"
          autoFocus
          aria-invalid={error}
          aria-describedby={error ? 'preloaded-access-error' : undefined}
        />
        <p className={styles.error} id="preloaded-access-error" role="alert">
          {error ? 'This code is not valid.' : ''}
        </p>
        <button className={styles.submit} type="submit">
          Enter
        </button>
      </form>
    </div>
  );
}

export default PreloadedGate;
